import theme from "../../../../components/styles/theme/theme";
import { CenterProps } from "../../../../features/map/types";
import { isRegion } from "../../../../config";

export const COLOR_ACTIVE = theme.palette.secondary[600];
export const HOVER_COLOR = theme.palette.secondary[800];
export const COLOR_DISABLED = theme.palette.text.disabled;

export const ZOOM_MAP = isRegion.latam ? 1 : isRegion.romania ? 13 : 1;
export const CENTER_MAP: CenterProps = isRegion.latam
  ? [-75, -18]
  : isRegion.romania
  ? [26, 46]
  : [-75, -18];

export type GeoMapProps = {
  geographies: any[];
};

export interface TopoJsonMap {
  type: string;
  arcs: number[][][];
  transform: Transform;
  objects: Objects;
}

export interface Transform {
  scale: number[];
  translate: number[];
}

export interface Objects {
  [key: string]: All;
}

export interface All {
  type: string;
  geometries: Geometry[];
}

export interface Geometry {
  arcs: any[][];
  type: string;
  properties: Properties;
}

export interface Properties {
  geo_point_2d: GeoPoint2d;
  iso3?: string;
  status: string;
  color_code: string;
  name: string;
  continent: string;
  region: string;
  iso_3166_1_alpha_2_codes?: string;
  french_short: string;
}

export interface GeoPoint2d {
  lon: number;
  lat: number;
}

// geographies
export interface GeographyProps {
  type: string;
  properties: Properties;
  geometry: Geometry;
  rsmKey: string;
  svgPath: string;
}

export interface GeoPoint2d {
  lon: number;
  lat: number;
}

export interface Geometry {
  type: string;
  coordinates: any[][][];
}
